import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';

interface TruncatedTextWithTooltipProps {
    text: string;
    maxLength: number;
    title?: string;
}

const TruncatedTextWithTooltip: React.FC<TruncatedTextWithTooltipProps> = ({ text, maxLength, title }) => {
    const [open, setOpen] = useState(false);
    const truncatedText = text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    const handleClickOpen = (event: React.MouseEvent) => {
        event.stopPropagation();
        setOpen(true);
    };

    const handleClose = (event: React.MouseEvent) => {
        event.stopPropagation();
        setOpen(false);
    };

    return (
        <>
            <Tooltip title={text} placement="top" arrow>
                <span className="ptf-0 cursor-pointer" onClick={handleClickOpen}>
                    {truncatedText}
                </span>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} aria-labelledby="truncated-text-dialog-title">
                { title && <DialogTitle id="truncated-text-dialog-title">{title}</DialogTitle>}
                <DialogContent>
                    <div>{text}</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TruncatedTextWithTooltip;
